import { Dictionary } from "lodash";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { GroupTitleTemplate } from "@ryde/controls";
import {
  GenericUploadRowConflictError,
  IGenericUploadRowConflict,
} from "@ryde/shared";

import { ResolveRowConflictsTable } from "./components";
import { GenericUploadRowConflictsContext } from "./contexts";

interface IGenericUploadRowConflictsProps {
  conflicts: Dictionary<IGenericUploadRowConflict[]>;
}

export const GenericUploadRowConflicts: FC<IGenericUploadRowConflictsProps> = ({
  conflicts,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <GroupTitleTemplate
        name="row-conflicts"
        formLabel={t("genericUpload.rowConflicts")}
      />
      {(Object.keys(conflicts) as GenericUploadRowConflictError[]).map(
        errorType => {
          return (
            <GenericUploadRowConflictsContext.Provider
              key={errorType}
              value={{
                conflicts: conflicts[errorType],
              }}
            >
              <ResolveRowConflictsTable errorType={errorType} />
            </GenericUploadRowConflictsContext.Provider>
          );
        },
      )}
    </>
  );
};
